<template>
  <div class="notice-list-wrapper">
    <Banner :bannerImg="Img1"></Banner>

    <!-- 面包屑 -->
    <div class="Crumbs container-fixed">
      <div>
        当前位置：<router-link to="/">首页</router-link> &gt;
        <span>通知公告列表</span>
      </div>
    </div>

    <main class="main-content container-fixed">
      <div class="section-header">
        <div class="en-title">NOTICES</div>
        <div class="cn-title">通知公告列表</div>
      </div>

      <div class="notice-container card-modern" v-loading="loading">
        <div
          v-for="(item, index) in infolist"
          :key="index"
          @click="getnoticeDetail(item.id)"
          class="notice-list-item"
        >
          <div class="item-main">
            <span class="dot"></span>
            <h3 class="item-title">{{ item.title }}</h3>
          </div>
          <div class="item-meta">
            <span class="date">{{ item.releaseTime }}</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <!-- 无数据状态 -->
        <div v-if="!loading && infolist.length === 0" class="empty-state">
          <i class="el-icon-document-delete"></i>
          <p>暂无通知公告</p>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Banner from "../components/banner.vue";
import article from "@/api/article";

export default {
  name: "NoticeList",
  components: {
    Banner,
  },
  data() {
    return {
      Img1: require("../assets/images/newsbanner.jpg"),
      infolist: [],
      loading: false,
    };
  },
  mounted() {
    this.getInfolist();
  },
  methods: {
    getInfolist() {
      this.loading = true;
      article
        .noticeList()
        .then((res) => {
          this.infolist = res.data.data.records;
          this.infolist.forEach((item) => {
            item.releaseTime = item.releaseTime.slice(0, 10);
          });
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    },
    getnoticeDetail(id) {
      this.$router.push({
        path: "/noticedetail",
        query: { id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/styles/variables.less";

.notice-list-wrapper {
  background-color: @bg-base;
}

.Crumbs {
  padding: 20px 0;
  font-size: 14px;
  color: @text-secondary;
  span {
    color: @text-main;
    font-weight: 500;
  }
  a:hover {
    color: @primary-color;
  }
}

.main-content {
  padding-bottom: 80px;
}

.notice-container {
  background: #ffffff;
  padding: 20px 40px;
  min-height: 400px;
}

.notice-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0;
  border-bottom: 1px dashed @border-color;
  cursor: pointer;
  transition: all 0.3s;

  &:last-child {
    border-bottom: none;
  }

  .item-main {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
    overflow: hidden;

    .dot {
      width: 6px;
      height: 6px;
      background: @text-muted;
      border-radius: 50%;
      flex-shrink: 0;
      transition: all 0.3s;
    }

    .item-title {
      font-size: 16px;
      font-weight: 500;
      color: @text-main;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      transition: all 0.3s;
    }
  }

  .item-meta {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-left: 40px;
    color: @text-muted;

    .date {
      font-size: 14px;
    }
    i {
      font-size: 16px;
      transform: translateX(0);
      transition: all 0.3s;
    }
  }

  &:hover {
    padding-left: 8px;
    .item-main {
      .dot {
        background: @primary-color;
        transform: scale(1.5);
      }
      .item-title {
        color: @primary-color;
      }
    }
    .item-meta i {
      color: @primary-color;
      transform: translateX(4px);
    }
  }
}

.empty-state {
  padding: 80px 0;
  text-align: center;
  color: @text-muted;
  i {
    font-size: 48px;
    margin-bottom: 16px;
  }
}
</style>
